import { LINKED_SCHEMA_TAG } from "@/app/features/shared/__to_be_integrated/types/forms/LinkedRefSchema";

export const RELATED_INFO_REF_SCHEMA_TAG = LINKED_SCHEMA_TAG;
